module.exports = __webpack_public_path__ + "img/0f5a1a8.jpg";